import React, { Component } from 'react';
import { getAuth0Client } from './auth0Client';
import { storeSession } from './session';

class Callback extends Component {
    async componentDidMount() {
        try {
            const client = getAuth0Client();
            await client.handleRedirectCallback();
            const tokenResult = await client.getTokenSilently({ detailedResponse: true });
            storeSession({
                accessToken: tokenResult.access_token,
                idToken: tokenResult.id_token,
                expiresIn: tokenResult.expires_in,
            });
            this.props.history.replace('/admin/dashboard');
        } catch (error) {
            if (typeof console !== 'undefined' && typeof console.error === 'function') {
                console.error('[auth0-callback]', error);
            }
            this.props.history.replace('/');
        }
    }

    render() {
        return (
            <div style={{
                minHeight: '100vh',
                background: '#1e1e2e',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}>
                <p style={{ color: '#ffffff', fontSize: '16px' }}>Signing in…</p>
            </div>
        );
    }
}

export default Callback;
